import { configureScope as configureSentryScope } from "@sentry/react"

export const AUTH = "AUTH"

const mapUser = (user) => ({ 
  ...user,
  birthDate: new Date(user.birthDate),
})

export function createAuth(user, token) {
  configureSentryScope(scope => { scope.setUser({ id: user.id, phone: user.phone }) })
  localStorage.setItem("token", token)
  localStorage.setItem("user", JSON.stringify(user))
  return {
    type: AUTH,
    payload: { user: mapUser(user), token },
  }
}

export function logout() {
  configureSentryScope(scope => { scope.setUser({ phone: null, id: null }) })
  localStorage.clear()
  return {
    type: AUTH,
    payload: null,
  }
}
